import AnnouncementsPage from '@/modules/admin/announcements/announcements-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/admin/announcements',
)({
  component: AnnouncementsPage,
});
